var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { ContactMethod } from "healthex-common/consentconfig.dtos";
import { computed, observable } from "mobx";
import { NOT_LOADED } from "../Infra/RemoteData";
import { NamedRoutes } from "./NamedRoutes";
import { SimpleDialogModel } from "./SimpleDialogModel";
import { getObservableT } from "../Infra/i18next";
import { GFIDProvider } from "healthex-common/healthcareorganization.dtos";
const t = getObservableT("patients");
export class PatientProfileViewModel {
    constructor(container) {
        this.smsOptInDialogModel = new SimpleDialogModel();
        this.smsOptInConfirmDialogModel = new SimpleDialogModel();
        this.smsOptInPollApiTimerId = null;
        this.smsOptInDialogOpenLimitTimerId = null;
        this.preferredContactMethodLocal = null;
        this.optOutDialogOpen = false;
        this.removeFromCurrentResearch = false;
        this.authManager = container.authManager;
        this.routingUIManager = container.routingUIManager;
        this.patientContactsUIManager = container.patientContactsUIManager;
        this.patientPreferencesManager = container.patientPreferencesManager;
        this.bannerUIManager = container.bannerUIManager;
    }
    run() { }
    stop() {
        this.clearSmsOptInPollApi();
        this.clearSmsOptInDialogOpenLimit();
    }
    get orgName() {
        return this.authManager.orgName;
    }
    get name() {
        return this.authManager.name;
    }
    get email() {
        return this.authManager.email;
    }
    get phone() {
        return this.authManager.formattedPhone;
    }
    get preferredContactMethodRemote() {
        return this.patientContactsUIManager.preferredContactMethod;
    }
    get isEmailRadioChecked() {
        return this.isRadioChecked(ContactMethod.EMAIL);
    }
    get isPhoneRadioChecked() {
        return this.isRadioChecked(ContactMethod.TEXT);
    }
    get isDoNotContactChecked() {
        return this.isRadioChecked(ContactMethod.DO_NOT_CONTACT);
    }
    get isOptedIn() {
        var _a, _b;
        if (this.patientPreferencesManager.preferences.value === NOT_LOADED)
            return NOT_LOADED;
        return !((_b = (_a = this.patientPreferencesManager.preferences.value) === null || _a === void 0 ? void 0 : _a.optedOut) !== null && _b !== void 0 ? _b : false);
    }
    get smsOptedOut() {
        var _a, _b;
        if (this.patientPreferencesManager.preferences.value === NOT_LOADED)
            return false;
        return (_b = (_a = this.patientPreferencesManager.preferences.value) === null || _a === void 0 ? void 0 : _a.smsOptedOut) !== null && _b !== void 0 ? _b : false;
    }
    get phoneNumberSuffix() {
        var _a, _b;
        if (this.patientPreferencesManager.preferences.value === NOT_LOADED)
            return null;
        return (_b = (_a = this.patientPreferencesManager.preferences.value) === null || _a === void 0 ? void 0 : _a.phoneNumberSuffix) !== null && _b !== void 0 ? _b : null;
    }
    get twilioFromPhoneNumber() {
        var _a, _b;
        if (this.patientPreferencesManager.preferences.value === NOT_LOADED)
            return null;
        return (_b = (_a = this.patientPreferencesManager.preferences.value) === null || _a === void 0 ? void 0 : _a.twilioFromPhoneNumber) !== null && _b !== void 0 ? _b : null;
    }
    get showPreferredContacts() {
        if (this.isOptedIn === NOT_LOADED)
            return NOT_LOADED;
        return this.isOptedIn && (!!this.email || !!this.phone);
    }
    get saveButtonEnabled() {
        return this.preferredContactMethodLocal !== null && this.showPreferredContacts;
    }
    get showSaveButton() {
        if (this.isOptedIn === NOT_LOADED)
            return false;
        return this.isOptedIn;
    }
    get isClearLogin() {
        return this.authManager.gfidProvider === GFIDProvider.CLEAR;
    }
    isRadioChecked(contactMethod) {
        if (this.preferredContactMethodLocal === null)
            return this.preferredContactMethodRemote === contactMethod;
        return this.preferredContactMethodLocal === contactMethod;
    }
    async updatedPreferredContactMethodLocal(contactMethod) {
        this.preferredContactMethodLocal = contactMethod;
        if (contactMethod === ContactMethod.TEXT && this.smsOptedOut) {
            await this.showSmsOptInDialog();
        }
    }
    updateRemoveFromCurrentResearch(val) {
        this.removeFromCurrentResearch = val;
    }
    goBack() {
        this.routingUIManager.navigateTo(NamedRoutes.PATIENT_MY_HEALTHEX);
    }
    async save() {
        if (!this.preferredContactMethodLocal)
            return;
        await this.patientPreferencesManager.updatePatientPreferences({ preferredContactMethod: this.preferredContactMethodLocal });
    }
    clearSmsOptInPollApi() {
        if (this.smsOptInPollApiTimerId !== null) {
            window.clearTimeout(this.smsOptInPollApiTimerId);
        }
    }
    calculateSmsOptInPollInterval(retries) {
        if (retries === 0)
            return 1000;
        if (retries === 1)
            return 10000;
        if (retries === 2)
            return 7500;
        if (retries < 10)
            return 5000;
        if (retries < 20)
            return 7500;
        if (retries < 30)
            return 10000;
        return 12000;
    }
    smsOptInPollApi(retries = 0) {
        this.clearSmsOptInPollApi();
        this.smsOptInPollApiTimerId = window.setTimeout(async () => {
            await this.patientPreferencesManager.preferences.waitForReload();
            if (!this.smsOptedOut) {
                this.smsOptInDialogModel.onChoice(true);
            }
            else {
                this.smsOptInPollApi(retries + 1);
            }
        }, this.calculateSmsOptInPollInterval(retries));
    }
    clearSmsOptInDialogOpenLimit() {
        if (this.smsOptInDialogOpenLimitTimerId !== null) {
            window.clearTimeout(this.smsOptInDialogOpenLimitTimerId);
        }
    }
    smsOptInDialogOpenLimit() {
        this.smsOptInDialogOpenLimitTimerId = window.setTimeout(async () => {
            this.smsOptInDialogModel.onChoice(false);
        }, 60000 * 15);
    }
    async showSmsOptInDialog() {
        this.smsOptInDialogModel.show();
        this.smsOptInPollApi();
        this.smsOptInDialogOpenLimit();
        const confirmed = await this.smsOptInDialogModel.showAndWait();
        if (this.smsOptInConfirmDialogModel.open)
            return;
        await this.smsOptInDialogClosed(confirmed);
    }
    async showSmsOptInConfirmDialog() {
        this.smsOptInConfirmDialogModel.show();
        if (this.smsOptInDialogModel.open)
            this.smsOptInDialogModel.onChoice(false);
        const confirmed = await this.smsOptInConfirmDialogModel.showAndWait();
        await this.smsOptInDialogClosed(confirmed);
    }
    async smsOptInDialogClosed(isSuccess) {
        this.clearSmsOptInPollApi();
        this.clearSmsOptInDialogOpenLimit();
        this.smsOptInDialogModel.open = false;
        if (isSuccess) {
            this.preferredContactMethodLocal = ContactMethod.TEXT;
            await this.save();
            this.bannerUIManager.displayBanner({ text: t("Your contact method has been successfully updated to Phone") });
        }
        else {
            if (this.preferredContactMethodRemote !== null &&
                this.preferredContactMethodRemote !== NOT_LOADED &&
                this.preferredContactMethodRemote !== ContactMethod.CALL) {
                this.preferredContactMethodLocal = this.preferredContactMethodRemote;
            }
            this.bannerUIManager.displayBanner({
                text: t("Your contact method was unable to be updated to Phone. Please try again"),
                type: "ERROR",
            });
        }
    }
    async deleteMyAccount() {
        this.routingUIManager.navigateTo(NamedRoutes.PATIENT_DELETE_MY_ACCOUNT);
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], PatientProfileViewModel.prototype, "preferredContactMethodLocal", void 0);
__decorate([
    observable,
    __metadata("design:type", Boolean)
], PatientProfileViewModel.prototype, "optOutDialogOpen", void 0);
__decorate([
    observable,
    __metadata("design:type", Boolean)
], PatientProfileViewModel.prototype, "removeFromCurrentResearch", void 0);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], PatientProfileViewModel.prototype, "orgName", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], PatientProfileViewModel.prototype, "name", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], PatientProfileViewModel.prototype, "email", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], PatientProfileViewModel.prototype, "phone", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], PatientProfileViewModel.prototype, "preferredContactMethodRemote", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], PatientProfileViewModel.prototype, "isEmailRadioChecked", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], PatientProfileViewModel.prototype, "isPhoneRadioChecked", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], PatientProfileViewModel.prototype, "isDoNotContactChecked", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], PatientProfileViewModel.prototype, "isOptedIn", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], PatientProfileViewModel.prototype, "smsOptedOut", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], PatientProfileViewModel.prototype, "phoneNumberSuffix", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], PatientProfileViewModel.prototype, "twilioFromPhoneNumber", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], PatientProfileViewModel.prototype, "showPreferredContacts", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], PatientProfileViewModel.prototype, "saveButtonEnabled", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], PatientProfileViewModel.prototype, "showSaveButton", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], PatientProfileViewModel.prototype, "isClearLogin", null);
